import { render } from "./OrderView.vue?vue&type=template&id=35c28202&scoped=true"
import script from "./OrderView.vue?vue&type=script&lang=js"
export * from "./OrderView.vue?vue&type=script&lang=js"

import "./OrderView.vue?vue&type=style&index=0&id=35c28202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c28202"]])

export default __exports__